export const TRIGGERED_PATTERNS = [
  "sms",
  "text",
  "email",
  "e-mail",
  "e_mail",
  "e mail",
  "klaviyo",
  "attentive",
  "mailchimp",
  "postscript",
  "flow",
  "sendgrid",
  "resci",
  "campaign",
  "triggered",
  "newsletter",
]

export const SOCIAL_REFERRAL_SOURCES = [
  "facebook.com",
  "instagram.com",
  "pinterest.com",
  "youtube.com",
  "linkedin.com",
  "reddit.com",
  "tiktok.com",
  "snapchat.com",
  "twitter.com",
]
